import { useMemo } from 'react';

import type { RoverBrand, RoverBrandContextType } from '@rover/types/src/RoverBrand';

export const useRoverBrandProvider = (brand: RoverBrand): RoverBrandContextType => {
  return useMemo(() => {
    return { brand };
  }, [brand]);
};
